import React from 'react';
import { Box, FlexBox, H1, Typography } from '@vp/swan';
import { useIdentityContext } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import { useCustomerQuery } from '../../graph/Customer.generated';

export function IntroHeader() {
    const { isSignedIn } = useIdentityContext();
    const profile = useCustomerQuery({
        skip: !isSignedIn,
    });

    return (
        <FlexBox style={{ width: '100%' }} justifyContent={'center'}>
            <Box pb={6}>
                <H1
                    fontSize={'x3large'}
                    fontWeight="bold"
                    textAlign={'center'}
                    id="project-overview"
                >
                    {timeBasedGreeting(profile.data?.customer?.firstName)}
                    <br />
                    {__('tell us about your new design project', {
                        _context:
                            "This is the second section of an incomplete sentence for the introduction title of the project brief form. Before this is a greeting which ends with a comma. e.g. 'Good morning 👋,'",
                    })}
                </H1>
                <Typography fontSize={'standard'} textAlign={'center'}>
                    {__(
                        'Please describe what you need designed. Share your vision and any details that will help your designer nail it.',
                        {
                            _context: 'This is the subheading for project brief introduction',
                        }
                    )}
                </Typography>
            </Box>
        </FlexBox>
    );
}

function timeBasedGreeting(name: string | undefined) {
    const currentHour = new Date().getHours();

    // translations don't work if we put _context into a const. This may be changed in the future once __ is updated to support it.
    if (name) {
        if (currentHour >= 5 && currentHour < 12) {
            return __(`Good morning, {{name}} 👋,`, {
                name: name,
                _context:
                    "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
            });
        }
        if (currentHour >= 12 && currentHour < 18) {
            return __(`Good afternoon, {{name}} 👋,`, {
                name: name,
                _context:
                    "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
            });
        }
        return __(`Good evening, {{name}} 👋,`, {
            name: name,
            _context:
                "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
        });
    } else {
        if (currentHour >= 5 && currentHour < 12) {
            return __(`Good morning 👋,`, {
                _context:
                    "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
            });
        }
        if (currentHour >= 12 && currentHour < 18) {
            return __(`Good afternoon 👋,`, {
                _context:
                    "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
            });
        }
        return __(`Good evening 👋,`, {
            _context:
                "This is the first section of an incomplete sentence for the introduction title of the project brief form. After the comma is the text 'tell us about your new design project'",
        });
    }
}
